import Api from '@/api'
import { each, find, sortBy } from 'lodash'
import OptionValue from '@/models/OptionValue'

export default {
  namespaced: true,

  state: {
    list: [],
  },

  mutations: {
    setOptionValueList(state, optionValues) {
      each(optionValues, (optionValue) => {
        const exist = find(state.list, { id: optionValue.id })
        if (!exist) {
          state.list.push(new OptionValue(optionValue))
        }
      })
    },

    clearOptionValueList(state) {
      state.list = []
    },
  },

  actions: {
    async getOptionValues({ commit }, type) {
      const { data } = await Api.get(`option-values/${type}`)
      commit('clearOptionValueList')
      commit('setOptionValueList', data.data)
    },

    // Returns the values without touching the shared list that
    // OptionsPickerModal reads.
    async fetchOptionValues(_, type) {
      const { data } = await Api.get(`option-values/${type}`)
      return sortBy(data.data, 'order_no')
    },
  },
}
